(function() {
  function addNav(modal, activeMediaId) {
    modal.querySelectorAll('.lightbox-nav').forEach(el => el.remove());

    const slides = Array.from(modal.querySelectorAll('[data-media-id]'));
    if (slides.length < 2) return;

    let current = slides.findIndex(s => s.getAttribute('data-media-id') === activeMediaId);
    if (current === -1) current = 0;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(s => s.classList.remove('active'));
      slides[current].classList.add('active');
      slides[current].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    const prev = document.createElement('button');
    const next = document.createElement('button');
    prev.className = 'lightbox-nav lightbox-nav--prev';
    next.className = 'lightbox-nav lightbox-nav--next';
    prev.innerHTML = '&#8592;';
    next.innerHTML = '&#8594;';

    prev.addEventListener('pointerdown', (e) => { 
      e.preventDefault();
      e.stopPropagation(); 
      e.stopImmediatePropagation();
      goTo(current - 1); 
    });
    next.addEventListener('pointerdown', (e) => { 
      e.preventDefault();
      e.stopPropagation(); 
      e.stopImmediatePropagation();
      goTo(current + 1); 
    });

    // Swipe
    let startX = 0;
    modal.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, {passive: true});
    modal.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(current + (diff > 0 ? 1 : -1));
    });

    // Klawiatura
    document.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Dodaj strzałki do aktywnego zdjęcia, nie do dialogu
    const activeSlide = slides[current];
    activeSlide.style.position = 'relative';
    activeSlide.appendChild(prev);
    activeSlide.appendChild(next);
  }

  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-media-id]');
    if (!opener) return;

    setTimeout(() => {
      const modal = document.querySelector('product-modal');
      if (modal) addNav(modal, opener.getAttribute('data-media-id'));
    }, 200);
  });
})();
